module.exports = __webpack_public_path__ + "static/media/on-hold-eh.93cf9444.png";